module.exports = __webpack_public_path__ + "static/media/hands.25cc12b0.png";